import {
    RaikoBaseCardContainer,
    RaikoCustomSelect, raikoCustomSelectItemGenerator,
    RaikoSectionContainer, showServerErrorMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {useEffect, useState} from "react";
import {GameStatusTypes} from "../../../pages/games/GameStatusTypes";
import {GameService} from "../../../serverService/gameService/GameService";
import {ServerErrorHandler} from "../../../service/errorHandler/ServerErrorHandler";

export default function GameAdmissionSettings({gameId}) {

    const [status, setStatus] = useState(GameStatusTypes.ARCHIVED.id);
    const service = new GameService()


    useEffect(() => {
        if (typeof service !== 'undefined') {
            getGameAdmissionSettingsFromServer()
        }
    }, []);


    function getGameAdmissionSettingsFromServer() {
        service.getGameAdmissionSettings(gameId)
            .then(response => {
                setStatus(response.status)
            }).catch(reason => {
            showServerErrorMessage(new ServerErrorHandler(reason).getMessage())
        })
    }

    function handleUpdateGameAdmissionSettingsFromServer() {
        service.updateGameAdmissionSettings(gameId, status)
            .then(
                response => {
                    showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
                }
            ).catch(reason => {
            showServerErrorMessage(new ServerErrorHandler(reason).getMessage())
        })
    }


    return (
        <RaikoBaseCardContainer>
            <RaikoSectionContainer
                title={"پذیرش"}
                hasActionButton
                actionButtonOnclick={handleUpdateGameAdmissionSettingsFromServer}
            >
                <RaikoCustomSelect
                    labelText={"تنظیمات مدیریتی"}
                    value={status}
                    setValue={setStatus}
                    items={[
                        raikoCustomSelectItemGenerator(GameStatusTypes.ARCHIVED.id, GameStatusTypes.ARCHIVED.title),
                        raikoCustomSelectItemGenerator(GameStatusTypes.PUBLISHED.id, GameStatusTypes.PUBLISHED.title),
                        raikoCustomSelectItemGenerator(GameStatusTypes.DRAFT.id, GameStatusTypes.DRAFT.title),
                        raikoCustomSelectItemGenerator(GameStatusTypes.SUSPENDED.id, GameStatusTypes.SUSPENDED.title),
                    ]}
                />

            </RaikoSectionContainer>

        </RaikoBaseCardContainer>
    )
}